module.exports = __webpack_public_path__ + "static/img/40009 (4).5d261c3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40009 (4).webp
// module id = iMPQ
// module chunks = 14